import React from 'react'
import styled from '@emotion/styled'
import { array, bool, func } from 'prop-types'

import { Link } from '@jelly/ui'
import { Arrow } from '../svgs/Arrow'
import { trackNavEvent } from './'

import { withStyles } from '@material-ui/styles'

const styles = (theme) => {
	return {
		FeaturedTopicContainer: {
			background: theme.palette.primary.main,
			height: '100%',
			width: '100%',
		},
		InnerFeaturedTopicContainer: {
			background: theme.palette.primary.main,
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
			width: 'auto',
			[theme.breakpoints.between('sm', 'md')]: {
				height: 'auto',
			},
			'& a:nth-of-type(odd)': {
				background: theme.palette.primary.light,
			},
			'& a:nth-of-type(even)': {
				background: theme.palette.primary.main,
			},
		},
		FeaturedTopicTitle: {
			fontFamily: theme.typography.h2.fontFamily,
			background: theme.palette.tertiary.main,
			color: theme.palette.common.white,
			display: 'flex',
			flexDirection: 'row',
			fontSize: '21px',
			height: 'auto',
			maxHeight: '80px',
			padding: '1rem',
			right: '0',
			textAlign: 'left',
			width: 'auto',
			[theme.breakpoints.up('sm')]: {
				padding: '2rem 1rem',
			},
			[theme.breakpoints.up('lg')]: {
				padding: '1rem',
			},
		},
	}
}

const Back = styled.button`
	background: none;
	border: 0;
	margin-right: 1rem;
	padding: 0;
	transform: rotate(90deg);
`
const ArrowBlock = styled.div`
	align-items: center;
	background: ${({ theme }) => theme.palette.secondary.main};
	bottom: 0;
	display: none;
	height: 27px;
	position: absolute;
	right: 0;
	width: 27px;

	svg {
		margin: auto;
		transform: rotate(270deg);
	}
`
const TopicContainer = styled(Link)`
	align-items: center;
	cursor: pointer;
	display: flex;
	font-size: 16px;
	height: auto;
	min-height: 75px;
	padding: 0 2.5rem 0 1rem;
	position: relative;
	text-align: left;
	&:hover {
		${ArrowBlock} {
			display: flex;
		}
	}

	${({ theme }) => theme.MQ.M} {
		height: calc(100% / 5);
		font-size: 14px;
	}
`
FeaturedTopics.propTypes = {
	handlePanel: func,
	showbackLink: bool,
	topics: array,
}
/**
 * Panel that displays a list of featured topics
 *
 * @param {Function} props.handlePanel :: handles featued topics panel display
 * @param {Object} props :: object of properties
 * @param {Boolean} props.showBackLink :: boolean value that helps determine what experience is shown
 * @param {Array} props.topics :: array of topics with the url path and title
 */
function FeaturedTopics({ classes, handlePanel, topics = [], showBackLink = false }) {
	const ARROW_DIMENSIONS = 15
	return (
		<div className={classes.FeaturedTopicContainer}>
			<div className={classes.InnerFeaturedTopicContainer}>
				<div className={classes.FeaturedTopicTitle}>
					{showBackLink && (
						<Back onClick={handlePanel} variant="secondary">
							{/* Back to Menu */}
							<Arrow height={24} width={24} />
						</Back>
					)}
					Featured Topics
				</div>
				{topics.map((topic, i) => {
					return (
						<TopicContainer
							href={topic.path}
							key={`featured-topic-${i}`}
							onClick={() => trackNavEvent({ destination: topic.path, type: 'Featured Topic' })}
							variant="light"
						>
							{topic.title}
							<ArrowBlock>
								<Arrow height={ARROW_DIMENSIONS} width={ARROW_DIMENSIONS} />
							</ArrowBlock>
						</TopicContainer>
					)
				})}
			</div>
		</div>
	)
}

export default withStyles(styles, { name: 'featuredTopics' })(FeaturedTopics)
